<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <!-- Header Block -->
  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex  ">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid m-t-md">
      <div class="row">
        <div class="card mb-4 ml-2 box-shadow full-height col-xs-12 col-md-4" *ngFor="let key of getKeys()"
          style="max-width:30%;">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">{{key}}</h4>
          </div>
          <div class="card-body d-flex flex-column" *ngIf="isArray(moleculeDetails.get(key));else singleElement">
            <h4 class="card-title pricing-card-title" *ngFor="let element of getValue(moleculeDetails, key)">
              <small class="text-muted btncolor font-weight-bold" (click)="serchValue(element)">{{element["Brand
                Name/Proprietary Name"]}}</small>
            </h4>
          </div>
          <ng-template #singleElement>
            <small class="text-muted btncolor font-weight-bold mt-3">{{moleculeDetails.get(key)["Brand Name/Proprietary
              Name"]}}</small>
          </ng-template>
        </div>

      </div>
    </div>







    <!-- <div *ngFor="let key of getKeys(moleculeDetails)">
      <div class="card">
        <div class="row">
          <div class="col">
            {{key }}
            <div *ngIf="isArray(moleculeDetails.get(key));else singleElement">
              <div *ngFor="let element of moleculeDetails.get(key)">
                <p>{{element["Brand Name/Proprietary Name"]}}</p>
              </div>
            </div>

            <ng-template #singleElement>
              <p>{{moleculeDetails.get(key)["Brand Name/Proprietary Name"]}}</p>
            </ng-template>

          </div>
        </div>

      </div>
    </div> -->







  </div>
</div>